import { zonedMoment } from './restaurantTime';

// Keep the last successfully refreshed day, so busy/failed refreshes are retried.
export const watchRestaurantDay = ({
    timezone,
    onDayChange,
    refreshOnStart = false,
    now = Date.now,
    setTimer = setTimeout,
    clearTimer = clearTimeout,
    windowTarget = window,
    documentTarget = document,
}) => {
    const dayAt = millis => zonedMoment(timezone, millis).format('YYYY-MM-DD');
    let refreshedDay = refreshOnStart ? null : dayAt(now());
    let timer;
    let stopped = false;
    let running = false;

    const schedule = () => {
        if (stopped) return;
        clearTimer(timer);
        const millis = now();
        const nextMidnight = zonedMoment(timezone, millis)
            .startOf('day').add(1, 'day').valueOf();
        const delay = dayAt(millis) === refreshedDay
            ? Math.max(1, nextMidnight - millis + 50)
            : 30000;
        timer = setTimer(check, delay);
    };

    const check = async () => {
        if (stopped || running) return;
        const day = dayAt(now());
        if (day !== refreshedDay) {
            running = true;
            try {
                if (await onDayChange() !== false && !stopped) {
                    refreshedDay = day;
                }
            } catch (_) {
                // Leave the day pending. Retry after a short delay on failure.
            } finally {
                running = false;
            }
        }
        schedule();
    };

    const onVisible = () => {
        if (documentTarget.visibilityState === 'visible') check();
    };
    windowTarget.addEventListener('focus', check);
    windowTarget.addEventListener('pageshow', check);
    documentTarget.addEventListener('visibilitychange', onVisible);
    if (refreshOnStart) check();
    else schedule();

    return () => {
        stopped = true;
        clearTimer(timer);
        windowTarget.removeEventListener('focus', check);
        windowTarget.removeEventListener('pageshow', check);
        documentTarget.removeEventListener('visibilitychange', onVisible);
    };
};
